"use client";

import { motion, useReducedMotion } from "motion/react";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  delay?: number;
  index?: number;
  step?: number;
  className?: string;
};

/**
 * Stagger reveal via clip-path mask. Content is always in the DOM; only the
 * mask animates, so crawlers and screen readers see the text from the start.
 */
export function RevealStagger({
  children,
  delay = 0,
  index = 0,
  step = 0.12,
  className = "",
}: Props) {
  const reduce = useReducedMotion();
  if (reduce) return <span className={className}>{children}</span>;
  return (
    <motion.span
      style={{ display: "inline-block", willChange: "clip-path" }}
      initial={{ clipPath: "inset(0 0 100% 0)" }}
      animate={{ clipPath: "inset(0 0 0% 0)" }}
      transition={{
        duration: 0.55,
        delay: delay + index * step,
        ease: [0.65, 0, 0.35, 1],
      }}
      className={className}
    >
      {children}
    </motion.span>
  );
}
